<template>
  <el-form class="serach-form" :inline="true" :model="filters" size="small">
    <el-form-item class="select_btn">
      <el-select
        class="select_btn_style"
        v-model="filters.finishStatus"
        placeholder="完成情况"
      >
        <el-option
          v-for="(item, i) in finishStatusData"
          :key="i"
          :label="item.paramValue"
          :value="item.paramKey"
        ></el-option>
      </el-select>
    </el-form-item>
    <el-form-item class="m-l-14">
      <el-input
        prefix-icon="el-icon-search"
        size="small"
        v-model.trim="filters.name"
        placeholder="姓名/工作单位"
      ></el-input>
    </el-form-item>
    <el-form-item>
      <butn btntype="primary" title="查询" @click="initData"></butn>
      <butn title="重置" @click="resetData" class="czButn"></butn>
    </el-form-item>
  </el-form>
</template>

<script>
import butn from "@/components/button/index";
import { getDataMap } from "@/api/sysParam";
export default {
  components: { butn },
  data() {
    return {
      filters: {},
      finishStatusData: []
    };
  },
  created() {
    getDataMap("WORK_FINISH_STATUS").then(res => {
      if (!res || res.code != 0) return;
      res.data.splice(0, 0, {
        paramKey: "",
        paramValue: "全部完成情况"
      });
      this.finishStatusData = res.data;
    });
  },
  methods: {
    initData() {
      this.$emit("search", this.filters);
    },
    resetData() {
      this.filters = {};
      this.initData();
    }
  }
};
</script>

<style lang="scss" scoped>
.serach-form {
  text-align: right;
}
</style>
